import FormField from './FormField';
import FormWrapper from './FormWrapper';
import CredentialSecurityNotice from './CredentialSecurityNotice';
import ConnectionTestButton from './ConnectionTestButton';
import type { FieldConfig } from './types';
import type { EhrConfig } from '../../types';
import { transformEhrConfigForTest } from '../../utils/connectionConfigTransformers';
import { useConnectionTest } from '../../hooks/useConnectionTest';

const fields: FieldConfig[] = [
    {
        name: 'baseUrl',
        label: 'Base URL',
        type: 'url',
        required: true,
        placeholder: 'http://54.146.19.136:8103',
        extra: 'FHIR server base URL (without /fhir/R4)',
    },
    {
        name: 'clientId',
        label: 'Client ID',
        type: 'text',
        required: true,
        placeholder: 'Enter OAuth2 client ID',
        isCredential: true,
    },
    {
        name: 'clientSecret',
        label: 'Client Secret',
        type: 'password',
        required: true,
        placeholder: 'Enter OAuth2 client secret',
        isCredential: true,
    },
];

interface EhrConfigFormProps {
    onConnectionTestSuccess?: () => void;
}

export default function EhrConfigForm({ onConnectionTestSuccess }: EhrConfigFormProps) {
    const { getConfig, handleTestConnection, isLoading } = useConnectionTest<EhrConfig>(
        transformEhrConfigForTest,
        config => Boolean(config?.baseUrl && config?.clientId && config?.clientSecret),
        onConnectionTestSuccess
    );

    return (
        <FormWrapper>
            <CredentialSecurityNotice />
            {fields.map(field => (
                <FormField
                    key={Array.isArray(field.name) ? field.name.join('.') : field.name}
                    config={field}
                />
            ))}
            {onConnectionTestSuccess && (
                <ConnectionTestButton
                    getConfig={getConfig}
                    testConnection={handleTestConnection}
                    isLoading={isLoading}
                    requiredFieldsMessage="Please fill in base URL, client ID, and client secret before testing the connection"
                />
            )}
        </FormWrapper>
    );
}
